import { INPUT_COLOR_BORDER, PRIMARY_COLOR } from "../../../../utils/colors";

export const ATTACHMENT_CHIP_VARIANTS = {
  LIGHT: "light",
  DARK: "dark",
};

const DARK_BUBBLE_ATTACHMENT_COLORS = {
  background: "rgba(255, 255, 255, 0.12)",
  backgroundHover: "rgba(255, 255, 255, 0.18)",
  text: "#ffffff",
  border: "rgba(255, 255, 255, 0.2)",
};

export const getDarkBubbleFileItemSx = ({
  backgroundHover = DARK_BUBBLE_ATTACHMENT_COLORS.backgroundHover,
} = {}) => ({
  backgroundColor: DARK_BUBBLE_ATTACHMENT_COLORS.background,
  border: `1px solid ${DARK_BUBBLE_ATTACHMENT_COLORS.border}`,
  color: DARK_BUBBLE_ATTACHMENT_COLORS.text,
  "&:hover": {
    backgroundColor: backgroundHover,
  },
});

export const getDarkBubbleIconSx = ({ fontSize = 20 } = {}) => ({
  fontSize,
  color: `${DARK_BUBBLE_ATTACHMENT_COLORS.text} !important`,
});

export const getLightBubbleIconSx = ({ fontSize = 20 } = {}) => ({
  fontSize,
  color: `${PRIMARY_COLOR} !important`,
});

export const getDarkBubbleChipSx = () => ({
  height: "auto",
  py: 0.5,
  color: DARK_BUBBLE_ATTACHMENT_COLORS.text,
  backgroundColor: DARK_BUBBLE_ATTACHMENT_COLORS.background,
  border: `1px solid ${DARK_BUBBLE_ATTACHMENT_COLORS.border}`,
  "& .MuiChip-label": {
    color: DARK_BUBBLE_ATTACHMENT_COLORS.text,
  },
  "&:hover": {
    backgroundColor: DARK_BUBBLE_ATTACHMENT_COLORS.backgroundHover,
  },
});

export const getAttachmentChipStyles = ({ variant, theme }) => {
  const isDark = variant === ATTACHMENT_CHIP_VARIANTS.DARK;
  const darkColors = DARK_BUBBLE_ATTACHMENT_COLORS;

  return {
    container: {
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      px: 1,
      py: 0.75,
      borderRadius: 1.5,
      maxWidth: 240,
      minWidth: 120,
      flexShrink: 0,
      position: "relative",
      border: isDark
        ? `1px solid ${darkColors.border}`
        : `1px solid ${INPUT_COLOR_BORDER}`,
      backgroundColor: isDark
        ? darkColors.background
        : theme.palette.action.hover,
      ...(isDark
        ? {
            "&:hover": {
              backgroundColor: darkColors.backgroundHover,
            },
          }
        : {}),
    },
    thumbnail: {
      width: 22,
      height: 22,
      borderRadius: 1,
      objectFit: "cover",
      flexShrink: 0,
      border: isDark
        ? `1px solid ${darkColors.border}`
        : `1px solid ${theme.palette.divider}`,
    },
    label: {
      color: isDark ? darkColors.text : theme.palette.text.secondary,
      flex: 1,
      minWidth: 0,
    },
  };
};

export const attachmentsScrollRowSx = {
  display: "flex",
  flexWrap: "nowrap",
  gap: 0.5,
  alignItems: "center",
  minHeight: 40,
  overflowX: "auto",
  overflowY: "hidden",
  pb: 0.5,
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

export const onAttachmentsRowWheel = (event) => {
  if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
    event.preventDefault();
    event.currentTarget.scrollLeft += event.deltaY;
  }
};
